import React from 'react';
import { Layout } from '../components/layout/Layout';
import { BackButton } from '../components/BackButton';
import { ComingSoonCard } from '../components/ComingSoonCard';
import '../styles/dashboard.css';

export const PlayPage = () => (
  <Layout>
    <div style={{ paddingTop: 40 }}>
      <BackButton />
      <ComingSoonCard
        title="Play Mode"
        description="Gamified practice sessions with scoring, streaks, and achievements to make therapy fun — in development. Check back soon."
      />
    </div>
  </Layout>
);
